var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"headline"},[_c('v-icon',[_vm._v("keyboard_backspace")]),_vm._v(" Виберіть пункт меню ліворуч ")],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }